import ChatHistory from "./ChatHistory.vue";

export default ChatHistory;
